import { FC, useEffect } from 'react';
import {createPortal} from 'react-dom'
import {Modal} from 'react-bootstrap'

import {useIntl} from 'react-intl'

interface Props {
  show: boolean
  handleClose: () => void
  handleConfirm: () => void
}

const modalsRoot = document.getElementById('root-modals') || document.body

const ConfirmModal: FC<Props> = ({ show, handleConfirm, handleClose }) => {
  
  const intl = useIntl()

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Enter') {
        handleConfirm();
      }
    };

    if (show) {
      document.addEventListener('keydown', handleKeyDown);
    }

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [show, handleConfirm]);

  return createPortal(
    <Modal
      tabIndex={-1}
      dialogClassName='modal-dialog modal-dialog-centered mw-300px'
      show={show}
      onHide={handleClose}
      backdrop={true}
    >
      <div className='modal-body p-10 text-center'>
        <h2 className="text-center mb-10">{intl.formatMessage({id: 'general.confirm.title'})}</h2>
        <button className="btn btn-danger me-2" onClick={handleConfirm}>{intl.formatMessage({id: 'general.confirm.yes'})}</button>
        <button className="btn btn-secondary" onClick={handleClose}>{intl.formatMessage({id: 'general.confirm.cancel'})}</button>
      </div>
    </Modal>,
    modalsRoot
  )
}
  
export {ConfirmModal}